/*todo: move to main store*/

import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export default class OverlayStore {
  overlay = false
}
